import { useState } from "react";
import { fetchTrainingHistoryReportCsv } from "../api/fetchTrainingHistoryReport/fetchTrainingHistoryReportCsvApi";
import { FetchTrainingHistoryReportParams } from "../api/fetchTrainingHistoryReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadTrainingHistoryReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchTrainingHistoryReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchTrainingHistoryReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `training-history-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
